module.exports = __webpack_public_path__ + "img/map.592d41ed.jpg";